<template>
  <div class="privilege" ref="privilege">
    <section class="privilege-card">
      <card-body :bought="bought" :startDate="startDate" :endDate="endDate"/>
    </section>

    <main class="privilege-details">
      <img @click.prevent v-for="(item, index) in imgList" :key="item+index" :src="item"/>
    </main>
    <!--:style="{ bottom }"-->
    <Notice @closeNotice="closeNotice" v-if="isNoticeShow && !isApp"></Notice>

    <footer v-if="!bought && footerShow"  class="privilege-payBar" ref="btn">
      <!-- <div class="privilege-payBar-sign">
        <img src="../assets/images/learning-card/icon.png" alt="">
      </div> -->
      <div class="privilege-payBar-price">
        <div class="privilege-payBar-price-countTime" v-if="countFlag > 0 && discountPrice < price && !isIosApp">
          <img src="../assets/images/privilege-icon.png" alt="">
          <p>升级倒计时{{showCountTime}}</p>
        </div>
        <p>
          ￥<em>{{discountPrice !== price && !isIosApp ? discountPrice : price}}</em> <span v-if="discountPrice < price && !isIosApp">￥{{price}}</span>
        </p>
        <p>总价值: <span>￥10000</span></p>
      </div>

      <app-button @click.native="pay" class="privilege-payBar-btn" type="privilege" width="270" height="80" fontSize="42" inlineBlock>
        立即开通
      </app-button>
    </footer>
  </div>
</template>

<script>
import os from '@edu-fe/os'
import api from '@edu-fe/api'
import keys from 'lodash.keys'
import module from '../modules/privilege'
import { mapState, mapActions } from 'vuex'
import Pay from '@edu-fe/pay'
import CardBody from '../components/PrivilegeCard/CardBody'
import AppButton from '../components/UI/Button'
import { setDate } from '../lib/dateUtils'
import { setTimeout } from 'timers'
import Notice from '../components/PrivilegeCard/PrivilegeNotice'

export default {
  name: 'privilege',

  data () {
    return {
      paying: false,
      timer: '',
      showCountTime: '',
      countFlag: 0,
      footerShow: false,
      imgList: [
        require('../assets/images/learning-card/2.png'),
        require('../assets/images/learning-card/3.png'),
        require('../assets/images/learning-card/4.png'),
        require('../assets/images/learning-card/5.png'),
      ],
      bottom: 0
    }
  },
  watch: {
    // userInfo (e) {
    //   const { userId } = e
    //   if (userId) {
    //     _dw.onEvent('card_visit', {
    //       user_id: userId
    //     })
    //   }
    // },
    cardId (e) {
      const { userId } = this.userInfo
       if (userId) {
        try {
          api.mine.track({
            client: 2,
            courseId: e,
            position: 2,
            type: 8,
            userId
          })()
        } catch (e) {
          console.log(e)
        }
      }
    },
    discountEndSeconds (e) {
      if (e > 0) {
        this.timer = setInterval(() => {
          if (typeof e === 'number') {
            e -= 1000
            this.showCountTime = setDate(e)
            this.countFlag = e
          }
        },1000)
      }
    }
  },
  computed: {
    ...mapState(['launchOptions', 'userInfo']),
    ...mapState(module.name, keys(module.state)),
    payBar () {
      return this.$refs.privilege
    },
    isApp () {
      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          return true
        }
      }
      return false
    },
    isIosApp () {
      if (os.type === 'app') {
        if (os.name === 'ios') {
          return true
        }
        return false
      }
    }
  },

  methods: {
    ...mapActions(module.name, keys(module.actions)),
    pay () {
      if (this.paying) return console.log('正在支付...')


      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          return os.sdk.pay.call({
            goodId: this.cardId,
            goodType: 8
          })
        }
      }

      this.paying = true
      /* eslint-disable */
      new Pay({
        courseId: this.cardId,
        type: 8,
        from: this.launchOptions.from,
        price: this.price,
        payment: true,
        loginCallback: wpsSid => {
          this.paying = false
        },
        gotoResult: orderId => {
          this.paying = false
          this.setBought(true)

          const page = location.protocol + '//' + location.host + '/sign-up-result-ok2?orderId=' + orderId + '&courseId=' + this.$route.query.courseId
          if (os.type === 'browser') {
            if (os.name === 'loan') {
              window.jsBridge && jsBridge.goToEduSuccess(JSON.stringify({
                page: 'KSWPSPageController',
                animated: false,
                urlString: page
              }))
              window.jsBridge && window.jsBridge.destroyActivity()
            } else {
              // window.location.replace('sign-up-result?orderId=' + orderId)
              window.location.href = page
            }
          } else {
            location.href = page
          }
        },
        gotoPayment: () => {
          this.paying = false
          this.$router.push({
            name: 'pay',
            query: {
              courseId: this.cardId,
              isSend: 0,
              type: 8
            }
          })
        },
        failCallback: () => {
          this.paying = false
        },
        cancelCallback: () => {
          this.paying = false
        }
      })
      /* eslint-enable */
    }
  },

  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },

  created () {
    this.init()
  },

  async mounted () {
    if (os.type === 'app' && os.name === 'ios') {
      const appInfo = JSON.parse(await os.sdk.use('getInformation'))
      // console.log('appInfo', appInfo)
      // console.log('typeof appInfo', typeof appInfo)
      // console.log('inReview', appInfo.inReview)
      // console.log('typeof inReview', typeof appInfo.inReview)
      // console.log('parseInt(inReview)', parseInt(appInfo.inReview))

      if (parseInt(appInfo.inReview) !== 1) {
        // APP正在审核, 不展示支付按钮
        return
      }
    }
    // this.payBar.addEventListener('touchmove', () => {
    //   console.log(this.payBar.scrollTop)
    //   this.bottom = `${-this.payBar.scrollTop}px`
    // })
    // this.payBar.addEventListener('scroll', () => {
    //   console.log(this.payBar.scrollTop)
    //   this.bottom = `${-this.payBar.scrollTop}px`
    // })
    // 兼容iosfixed问题
    setTimeout(() => {
      this.footerShow = true
    }, 100)
  },

  beforeDestroy () {
    window.clearInterval(this.timer)
    this.$store.unregisterModule(module.name)
  },
  components: {
    CardBody,
    AppButton,
    Notice
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.privilege {
  position: relative;
  // height: 100%;
  width: 100%;
  background-color: #D8D8D8;
  &-card {
    // padding-top: rem(57);
    text-align: center;
  }

  &-details {
    margin-top: rem(-159);
    padding-top: rem(125);
    padding-bottom: rem(140);
    box-sizing: border-box;
    background-color: #f6f6f6;
    img {
      display: block;
      width: 100%;
      // margin: rem(30) auto;
      // transform: translateX(use(-15));
    }
  }

  &-payBar {
    position: fixed;
    transform: translateZ(0);
    -webkit-font-smoothing: antialiased;
    bottom: 0;
    left: 0;
    height: rem(146);
    width: 100%;
    padding-right: rem(30);
    padding-left: rem(30);
    box-sizing: border-box;
    border-top: 1px solid #E4E4E4;
    background: linear-gradient(#263142, #161b25);

    display: flex;
    align-items: center;
    justify-content: space-between;

    &-sign {
      position: absolute;
      top: rem(-20);
      left: 23%;
      > img {
        width: rem(170);
      }
    }
    &-price {
      color: #edd12b;
      font-size: rem(28);
      // display: flex;
      // align-items: baseline;
      position: relative;
      em {
        font-size: rem(60);
        margin-right: rem(10)
      }
      span {
        text-decoration:line-through;
      }
      >p {
        line-height: 1.2;
        &:last-child {
          font-size: rem(24);
          color: #9B9B9B;
        }
      }
      &-countTime {
        position: absolute;
        top: rem(-50);
        width: rem(270);
        text-align: center;
        >p {
          font-size: rem(24);
          color: #fff;
          line-height: rem(40);
        }
        > img {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
        }
      }
    }
    // span {
    //   float: left;
    //   line-height: rem(126);
    //   color: #f00;
    //   font-size: rem(26);
    // }

    // em {
    //   float: left;
    //   line-height: rem(118);
    //   color: #f00;
    //   font-size: rem(40);
    // }

    &-btn {
      float: right;
      // margin-top: rem(20);
      font-weight: bold;
      font-size: rem(55);
    }
  }
}
</style>
